import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { AppSettings } from '../shared/AppSettings';
import { OrderDetails } from '../model/orderDetails';

@Injectable()
export class OrderService {
  readonly rootUrl = AppSettings.webApiURL; 

  constructor(public httpClient: HttpClient) { }


  // Customer ----------------------------------------------------------

  public GetCustomerSuppliers() {
    return this.httpClient.get(`${this.rootUrl}/api/CustomerOrder/GetCustomerSuppliers`);
  }

  public GetCustomerSuppliersByCustomer(customerId) {
    return this.httpClient.get(`${this.rootUrl}/api/CustomerOrder/GetCustomerSuppliersByCustomer?customerId=${customerId}`);
  }

  public GetCustomerOrderStatuses() {
    return this.httpClient.get(`${this.rootUrl}/api/CustomerOrder/GetCustomerOrderStatuses`);
  }

  public getCustomerOrders(orderFilter) {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.httpClient.post(`${this.rootUrl}/api/CustomerOrder/GetCustomerOrders`, orderFilter, { headers });
  }

  public getCustomerOrderDetails(orderFilterByOrderIdEncoded) {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.httpClient.post(`${this.rootUrl}/api/CustomerOrder/GetCustomerOrderDetails`, orderFilterByOrderIdEncoded, { headers });
  }

  public getOrderByOrderNumberDetails(orderNumber) {
    return this.httpClient.get(`${this.rootUrl}/api/CustomerOrder/GetOrderByOrderNumberDetails?orderNumber=${orderNumber}`);
  }

  // Supplier ----------------------------------------------------------

  public GetSupplierOrderStatuses() {
    return this.httpClient.get(`${this.rootUrl}/api/SupplierOrder/GetSupplierOrderStatuses`);
  }  

  public getSupplierOrders(orderFilter) {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.httpClient.post(`${this.rootUrl}/api/SupplierOrder/GetSupplierOrders`, orderFilter, { headers });
  }

  public getSupplierOrderDetails(orderFilterByOrderIdEncoded) {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.httpClient.post(`${this.rootUrl}/api/SupplierOrder/GetSupplierOrderDetails`, orderFilterByOrderIdEncoded, { headers });
  }


  // Supplier Invoice  --------------------------------------------------
  
  public SupplierInvoiceSend(invoice) {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.httpClient.post(`${this.rootUrl}/api/SupplierOrder/SupplierInvoiceSend`, invoice, { headers });
  }

  public isInvoiceNumberForSupplierExist(invoiceNumber) {
    return this.httpClient.get(`${this.rootUrl}/api/SupplierInvoice/isInvoiceNumberForSupplierExist?InvoiceNumber=` + invoiceNumber);
  }

  ///////////////////  New Order  ///////////////////

  public createNewOrder = (orderDetails : OrderDetails) => {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.httpClient.post(`${this.rootUrl}/api/SupplierOrder/CreateNewOrder`, orderDetails, { headers });
  }

  //////////////////////  Get Order Details  ///////////////

  public getOrderDetailsByOrderNumber = (orderNumber : string) => {
    return this.httpClient.get(`${this.rootUrl}/api/SupplierOrder/GetOrderDetailsByOrderNumber/${orderNumber}`,);
  }

 //////////////////////  Update Order  ///////////////

 public updateOrder = (orderDetails : OrderDetails) => {
  return this.httpClient.post(`${this.rootUrl}/api/SupplierOrder/UpdateOrder`, orderDetails);
 }
  
 //////////////////////  Get Order Details with orderId  ///////////////

public GetOrderDetailsByOrderId = (orderId: number) => {
  return this.httpClient.get(`${this.rootUrl}/api/CustomerOrder/GetOrderDetailsByOrderId?orderId=${orderId}`);
};


}



// WEBPACK FOOTER //
// C:/MyProjects_Git/GoDocu/GoDocuMng/Client/src/app/service/order.service.ts